import CryptoJS from 'crypto-js'

export const computeWinrestHash = (url) => {
    let path = `service/v1/${url}&key=LoungeUpMobileAPI`;
    const res = CryptoJS.MD5(path);
    return res.toString();
};